/*
  De collage van Het Archief.

  De tegels staan tegen elkaar aan in een rail. De pijlen schuiven precies één
  tegel op; op een telefoon veegt de bezoeker en houden de streepjes bij waar
  hij is. Aan het begin en het eind staan de pijlen uit, zodat er geen knop is
  die niets doet.

  Zonder JavaScript blijft de rail gewoon een veegrail, alleen zonder pijlen
  en zonder streepjes.
*/
(function () {
  'use strict';

  function start(vak) {
    var rail = vak.querySelector('[data-mgridrail]');
    if (!rail) return;

    var terug = vak.querySelector('[data-mgridterug]');
    var verder = vak.querySelector('[data-mgridverder]');
    var punten = vak.parentNode ? vak.parentNode.querySelector('[data-mgridpunten]') : null;

    /* Eén tegel plus de tussenruimte -- die is hier nul, maar niet gegarandeerd. */
    function stap() {
      var eerste = rail.firstElementChild;
      if (!eerste) return rail.clientWidth;
      var gat = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      return eerste.getBoundingClientRect().width + gat;
    }

    function ververs() {
      var ruimte = rail.scrollWidth - rail.clientWidth;
      if (terug) terug.disabled = rail.scrollLeft <= 1;
      if (verder) verder.disabled = rail.scrollLeft >= ruimte - 1;

      if (punten && punten.children.length) {
        var breedte = stap();
        var bij = breedte ? Math.round(rail.scrollLeft / breedte) : 0;
        for (var i = 0; i < punten.children.length; i++) {
          punten.children[i].classList.toggle('is-actief', i === bij);
        }
      }
    }

    if (punten && !punten.children.length) {
      var aantal = rail.children.length;
      if (aantal > 1) {
        for (var i = 0; i < aantal; i++) {
          var punt = document.createElement('span');
          punt.className = 'mgrid__punt' + (i === 0 ? ' is-actief' : '');
          punten.appendChild(punt);
        }
      }
    }

    /*
      Het schuiven is met de hand geschreven en niet met `behavior: 'smooth'`:
      zo is de stap altijd precies één tegel, en werken de pijlen ook in
      browsers die die optie niet kennen -- daar doet scrollBy anders niets.
    */
    var loopt = null;

    function schuif(richting) {
      var afstand = stap() * richting;
      if (!afstand) return;

      var van = rail.scrollLeft;
      var naar = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, van + afstand));
      if (naar === van) return;

      if (loopt) window.cancelAnimationFrame(loopt);

      /* Wie beweging heeft uitgezet, krijgt de sprong. */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rail.scrollLeft = naar;
        ververs();
        return;
      }

      var begin = 0;
      var duur = 240;

      function beweeg(nu) {
        if (!begin) begin = nu;
        var deel = Math.min(1, (nu - begin) / duur);
        var soepel = deel < 0.5 ? 2 * deel * deel : -1 + (4 - 2 * deel) * deel;
        rail.scrollLeft = van + (naar - van) * soepel;
        if (deel < 1) {
          loopt = window.requestAnimationFrame(beweeg);
        } else {
          rail.scrollLeft = naar;
          loopt = null;
          ververs();
        }
      }

      loopt = window.requestAnimationFrame(beweeg);
    }

    if (terug) terug.addEventListener('click', function () { schuif(-1); });
    if (verder) verder.addEventListener('click', function () { schuif(1); });

    var wacht = false;
    rail.addEventListener('scroll', function () {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(function () {
        wacht = false;
        ververs();
      });
    });

    window.addEventListener('resize', ververs);
    ververs();
    window.addEventListener('load', ververs);
  }

  function alles(wortel) {
    var vakken = (wortel || document).querySelectorAll('[data-mgridcollage]');
    for (var i = 0; i < vakken.length; i++) start(vakken[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(); });
  } else {
    alles();
  }

  /* In de theme editor wordt een sectie opnieuw ingevoegd zonder herladen. */
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
